// src/pages/admin/CreateEvent.tsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { useDarkMode } from "../../context/DarkModeContext";
import EventForm from "../../components/EventForm";
import type { Event } from "../../types/event";
import { ArrowLeft } from "lucide-react";

const CreateEvent: React.FC = () => {
  const navigate = useNavigate();
  const { isDark } = useDarkMode();

  const handleSave = (event: Event) => {
    // Handle event save
    console.log("Event saved:", event);
    navigate("/dashboard/events-manager");
  };

  const handleCancel = () => {
    navigate("/dashboard/events-manager"); // Fixed: Navigate back to events manager
  };

  return (
    <div
      className={`min-h-screen py-8 px-4 sm:px-6 lg:px-8 transition-colors duration-300 ${
        isDark
          ? "bg-gray-900 text-gray-100"
          : "bg-gradient-to-br from-sky-50 to-blue-50 text-gray-900"
      }`}
    >
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="flex items-center mb-8">
          <button
            onClick={() => navigate("/dashboard/events-manager")}
            className={`mr-4 p-2 rounded-lg transition-colors ${
              isDark
                ? "hover:bg-gray-800 text-gray-400 hover:text-white"
                : "hover:bg-blue-100 text-blue-600 hover:text-blue-800"
            }`}
          >
            <ArrowLeft className="w-5 h-5" />
          </button>
          <div>
            <h1
              className={`text-3xl sm:text-4xl font-bold bg-gradient-to-r ${
                isDark
                  ? "from-blue-400 to-blue-600 text-white"
                  : "from-sky-500 to-blue-600 text-transparent bg-clip-text"
              }`}
            >
              Create New Event
            </h1>
            <p className={`mt-2 ${isDark ? "text-gray-400" : "text-blue-700"}`}>
              Schedule a new event for the community
            </p>
          </div>
        </div>

        <EventForm onSave={handleSave} onCancel={handleCancel} />
      </div>
    </div>
  );
};

export default CreateEvent;
